import './style.css';
import { bootstrap } from './bootstrap';

declare global {
  interface Window {
    /** The build-time environment, published in development for inspecting from the console. */
    __APP_CONFIG__?: ImportMetaEnv;
  }
}

if (import.meta.env.NODE_ENV === 'development') {
  window.__APP_CONFIG__ = import.meta.env;
}

void bootstrap();
